var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSup2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 643.57,
    height: 514.389,
    viewBox: "0 0 643.57 514.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#44bba4;}.a,.e{opacity:0.1;}.c{fill:#46455b;}.d{fill:#3f3d56;}.f{fill:#323444;}.g{fill:#fbb3b2;}.h{fill:#5b5583;}.i{fill:#3c354c;}.j{fill:#cbceda;}.k{fill:#a8a8a8;}.l{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 88.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 105.864)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 123.508)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 61.754)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 79.398)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 97.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 88.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 105.864)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 123.508)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 61.754)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 79.398)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 97.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 26.466)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 44.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 61.754)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 17.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 35.288)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 26.466)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 44.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 61.754)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 17.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 35.288)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 402.418)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 420.062)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 437.706)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 375.952)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 393.596)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 411.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 402.418)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 420.062)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 437.706)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 375.952)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 393.596)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 411.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 340.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 358.308)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 375.952)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(131.563 314.198)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(192.638 331.842)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(253.713 349.486)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 340.664)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 358.308)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 375.952)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(321.574 314.198)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(382.65 331.842)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.361,
    height: 17.644,
    rx: 7.43,
    transform: "translate(443.725 349.486)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 297.572,
    cy: 24.43,
    rx: 297.572,
    ry: 24.43,
    transform: "translate(29.771 465.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.265,254.042c28.061,12.161,44.185,37.324,44.185,37.324S198.072,296.794,170,284.64s-44.185-37.324-44.185-37.324S155.2,241.881,183.265,254.042Z",
    transform: "translate(-125.82 -127.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M333.584,179.037c8.679-14.251,23.46-21.037,23.46-21.037s.679,16.246-7.974,30.456-23.466,20.99-23.466,20.99S324.9,193.206,333.584,179.037Z",
    transform: "translate(-190.023 -98.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M242.137,190.856c6.209,22.164,23.324,36.754,23.324,36.754s7.051-21.356.841-43.526-23.331-36.754-23.331-36.754S235.921,168.686,242.137,190.856Z",
    transform: "translate(-162.379 -95.531)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 494.709,
    height: 247.694,
    rx: 7.21,
    transform: "translate(80.667 94.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M118.87,482H613.579v10.037a4.893,4.893,0,0,1-4.893,4.893H123.763a4.893,4.893,0,0,1-4.893-4.893Z",
    transform: "translate(-38.203 -154.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 36.645,
    height: 18.323,
    rx: 2.5,
    transform: "translate(128.848 308.769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 25.109,
    height: 2.714,
    rx: 1.357,
    transform: "translate(175.673 324.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M332.788,275.863c17.909,3.3,36.177,0,54.011-2.239l54.2-6.786c2.192-.278,5.381-1.588,6.671,1.093.726,1.5.237,4.75.292,6.474.143,4.75.129,9.5,0,14.251-.244,9.08-.909,18.139-1.758,27.178-1.649,17.691-3.983,35.288-5.151,53.047-.6,9.039-.9,18.105-.631,27.145.061,2.158.149,4.316.278,6.467.142,2.409,1.221,5.985-1.4,7.594-1.5.923-4.452.875-6.169,1.147-2.714.428-5.429.767-8.2,1.045-18.248,1.825-36.733,1.065-55.049.957l-55.307-.285-13.491-.075c-1.221,0-5.626.733-6.379-.719-.319-.618.529-3.508.679-4.282q.312-1.914.679-3.821c1.574-8.924,3.434-17.793,5.307-26.656,4.024-19,8.143-38.1,9.8-57.506.821-9.738.278-19.564,1.283-29.282.468-4.513,1.025-14.583,7.03-14.984,5.09-.339,10.328,0,15.432,0a1.018,1.018,0,1,0,0-2.036c-4.818,0-9.643-.129-14.461-.034-3.2.061-5.429.821-6.956,3.766-3.9,7.56-3.5,17.644-3.624,25.9-.292,19.754-3.325,39.088-7.275,58.408-1.988,9.725-4.133,19.415-6.108,29.146-.93,4.649-1.819,9.311-2.633,13.986-.38,2.226-2.3,7.132-.611,9.175s6.888.943,9.216.957l16.192.1,31.026.176c20.046.115,40.16.679,60.2.088,9.568-.285,19.68-.679,29-2.966,2.776-.679,4.112-1.954,4.221-4.913.163-4.587-.584-9.317-.679-13.925-.679-39.427,8.584-78.305,7.634-117.746-.061-2.681.95-9.44-1.982-11.061-1.316-.733-3.027-.332-4.411-.17-2.647.305-5.286.679-7.933.991l-34.372,4.289c-10.987,1.357-21.967,2.823-32.974,4.072-11.652,1.357-23.419,2.165-35.03,0-1.283-.238-1.832,1.724-.543,1.961Z",
    transform: "translate(-179.408 -133.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M319.536,312.615l135.6-6.65c1.31-.068,1.317-2.1,0-2.036l-135.6,6.65C318.233,310.641,318.226,312.677,319.536,312.615Z",
    transform: "translate(-187.763 -145.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M381.122,288.893a3.393,3.393,0,0,0,1.2,5.476c1.825.835,3.97.136,5.782-.319,2.714-.679,5.429-1.283,8.218-1.778a112.076,112.076,0,0,1,18.384-1.71c2.81-.034,5.6.1,8.408.217,2.036.081,4.228.244,5.951-1.018,1.968-1.439,2.606-4.248.679-6-2.714-2.477-8.564-1.038-11.7-.78a262.355,262.355,0,0,0-33.836,5.049c-1.276.271-.74,2.239.543,1.961q11.041-2.382,22.252-3.827,5.51-.679,11.041-1.147c1.737-.143,3.475-.271,5.212-.373.679-.041,1.4-.115,2.09-.1,2.151.047,2.4-.339,1.113,2.26-1.147,2.3-.78,2.036-2.769,1.961-.841,0-1.683-.1-2.524-.136q-2.585-.109-5.171-.115-5.5,0-10.98.529c-3.095.3-6.182.719-9.243,1.262-1.914.339-3.814.733-5.707,1.167-.835.2-1.676.4-2.511.611-.4.109-.808.2-1.208.305q-2.226.774-3.793-2.036c.909-.943-.523-2.389-1.439-1.439Z",
    transform: "translate(-207.573 -138.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M402.458,333.938c-9.82-.38-20.426,2.273-26.893,10.179-5.062,6.182-7.947,16.789-2.586,23.751,5.761,7.465,18.4,6.148,26.018,2.966,8.062-3.393,16.884-10.39,19.307-19.144,3.02-10.932-6.786-19.2-17-19.32a1.019,1.019,0,0,0,0,2.036c5.823.068,11.536,2.565,14.251,7.987,2.843,5.714.394,11.713-3.393,16.287-6.067,7.282-15.554,12.772-25.217,12.615-5.8-.088-12.215-2.077-14.013-8.2-1.479-4.961-.353-10.383,2.226-14.78,5.578-9.5,16.931-12.717,27.341-12.31,1.31.048,1.31-1.988,0-2.036Z",
    transform: "translate(-204.33 -155.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M401.721,353.68a2.647,2.647,0,0,0-3.556,2.714c.2,2.647,3.122,3.393,5.314,3.237,1.893-.163,4.106-.862,3.441-3.23a3.04,3.04,0,0,0-1.656-1.914,3.834,3.834,0,0,0-1.914-.238c-.251,0-2.552.842-1.574-.17l-1.6-.21a1.669,1.669,0,0,1,.489,1.357,1.025,1.025,0,0,0,1.527.875,1.357,1.357,0,0,1,1.839,1.588,1.025,1.025,0,0,0,1.859.787c.679-1.221,1.5-3.651.482-4.927-.679-.862-1.988-.6-2.8-.1a9.82,9.82,0,0,0-1.4,1.2c-.821.726-1.357,1.065-1.052-.326.509-2.531,2.925-4.547,5.13-5.558l-1.493-1.147a21.457,21.457,0,0,1-4.106,8.042l1.737.719a4.533,4.533,0,0,1,2.769-4.418h-1l.529.869c-.2,1.283,1.764,1.832,1.961.536.258-1.676-.8-3.854-2.762-3.033-2.341.977-3.556,3.658-3.508,6.046,0,.814,1.154,1.445,1.744.726a23.928,23.928,0,0,0,4.621-8.951,1.031,1.031,0,0,0-1.5-1.147,11.381,11.381,0,0,0-4.94,4.3c-.828,1.357-1.866,3.475-1.025,5.035a2.158,2.158,0,0,0,2.952.835,7.942,7.942,0,0,0,1.7-1.357c.251-.224.529-.611.862-.679.3-.2.285-.088-.048.36a3.7,3.7,0,0,1-.59,1.982l1.859.78a3.393,3.393,0,0,0-4.825-3.888l1.534.882a3.7,3.7,0,0,0-.767-2.4,1.031,1.031,0,0,0-1.595-.21,2.662,2.662,0,0,0,.068,3.943c.97.74,1.445,0,2.511-.17,3.617-.468,1.507,1.16.231,1.215a4.812,4.812,0,0,1-1.7-.122q-2.124-.719-.265-1.853c1.215.5,1.737-1.473.543-1.961Z",
    transform: "translate(-213.345 -159.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.207,361.787c.835,2.714-2.613,3.61-4.248,4.547a9.46,9.46,0,0,0-2.938,2.572c-1.71,2.294-2.348,5.212-2.911,7.96-.258,1.283,1.7,1.825,1.968.543a23.072,23.072,0,0,1,1.717-5.856c1.221-2.429,2.972-3.244,5.252-4.492s3.929-3.183,3.122-5.816c-.38-1.249-2.348-.713-1.961.543Z",
    transform: "translate(-209.466 -164.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.86,360.37a1.968,1.968,0,0,0-1.7,2.036c0,.808.536,1.323.9,1.968a15.54,15.54,0,0,1,1.968,4.282c.326,1.459.645,4.072-.115,5.429-1.4,2.518-3.943,2.036-6.108,2.036-2.036,0-3.61.679-3.542-2.158.041-1.595,1.154-3.21,2.036-4.465l-1.859-.244a35.468,35.468,0,0,1,.618,6.284c0,.943,1.445,1.466,1.893.509a39.313,39.313,0,0,0,2.586-7.153l-2-.271.353,5.157a1.025,1.025,0,0,0,1.893.516,2.307,2.307,0,0,0,.509-.916c.068-.319-.556-2.47-.808-1.7l2,.271.143-4.9-2.036.271a10.138,10.138,0,0,1,.38,4.275c-.129,1.133,1.778,1.391,2.036.271l1.276-6.583-1.859.238a4.5,4.5,0,0,1,.346,2.932c-.149,1.3,1.887,1.289,2.036,0a7.152,7.152,0,0,0-.624-3.956,1.025,1.025,0,0,0-1.859.244l-1.283,6.583,2,.271a11.1,11.1,0,0,0-.455-4.811,1.018,1.018,0,0,0-2,.265l-.142,4.9a1.023,1.023,0,0,0,2,.271l.109-.332a1.031,1.031,0,0,0-.258-.991c-2.11-2.294-2.538,1.357-3.271,2.368l1.9.516-.353-5.157a1.024,1.024,0,0,0-2-.271,36.487,36.487,0,0,1-2.375,6.671l1.9.516a38.369,38.369,0,0,0-.679-6.827c-.176-.936-1.4-.9-1.859-.244-1.357,1.954-3.705,6.223-1.893,8.564,1.581,2.036,6.555,1.249,8.68,1.12,3.352-.19,4.567-2.314,4.933-5.476a13.409,13.409,0,0,0-.251-4.533c-.183-.8-2.036-5.877-2.592-5.775,1.289-.237.74-2.205-.543-1.968Z",
    transform: "translate(-210.726 -164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M397.358,365.783l-5.558,7.336,1.758,1.025,4.072-5.89-1.859-.787-2.029,7.743A1.025,1.025,0,0,0,395.6,376a35.765,35.765,0,0,1,3.1-4.363l-1.7-.991a11.081,11.081,0,0,1-2.558,4.7l1.7.991a9.1,9.1,0,0,1,.74-2.714c.523-1.174-1.133-2.212-1.758-1.031a23.9,23.9,0,0,1-1.961,3.081l1.859.244.414-1.934-1.859-.244.3,1.7a1.025,1.025,0,0,0,1.7.448,20.264,20.264,0,0,0,4.072-6.141h-1.751a9.141,9.141,0,0,1,.957,2.714c.244,1.222,1.866.767,2-.271a55.191,55.191,0,0,0,.448-6.854h-2.036V369.6c0,1.106,1.812,1.432,2,.271a7.778,7.778,0,0,1,1-2.918h-1.785a4.526,4.526,0,0,1,.679,2.307,1.018,1.018,0,0,0,2.036,0l.258-1.357H401.5c.2,1.2.943,7.967-1.71,7.173-.448-.109-.577-.081-.387.075l.6-1.289,1.418-3.006-1.9-.516c.122,1.4.251,3.393-.59,4.587a3.515,3.515,0,0,1-3.834.787,6.787,6.787,0,0,1-1.771-1.859l-1.391,1.357c1.126.821,2.952,2.837,4.4,2.952,1.106.088,2.036-.828,2.762-1.561a11.828,11.828,0,0,0,3.318-8.707,1.018,1.018,0,0,0-2.036,0v2.321a1.018,1.018,0,1,0,2.036,0V364.52a1.018,1.018,0,0,0-2.036,0,24.425,24.425,0,0,1-.353,4.072l2,.271a46.883,46.883,0,0,1-.224-4.879,1.018,1.018,0,0,0-2-.271c-.305,1.3-.679,2.572-1.038,3.841l1.859-.244-.143-.543c-.1-1.3-2.131-1.3-2.036,0a3.725,3.725,0,0,0,.421,1.574,1.029,1.029,0,0,0,1.859-.244c.387-1.276.733-2.552,1.038-3.841l-2-.271a46.883,46.883,0,0,0,.224,4.879c.1,1.045,1.785,1.493,2,.271a28.05,28.05,0,0,0,.428-4.642h-2.036v5.694h2.036v-2.321h-2.036a9.786,9.786,0,0,1-2.477,6.976,8.331,8.331,0,0,1-.855.841c-.482.461-.923.394-1.31-.21a16.953,16.953,0,0,1-2.8-2.036c-.841-.6-2,.59-1.4,1.391,1.561,2.077,3.888,4.391,6.786,3.393,3.047-1.079,3.461-5.2,3.23-7.919-.075-.9-1.425-1.513-1.893-.509-.679,1.432-1.357,2.857-2.036,4.3a3.8,3.8,0,0,0-.611,1.792c.224,1.527,2.077,1.276,3.217,1.188,4.418-.332,3.719-6.6,3.21-9.745-.17-1.045-1.69-.882-1.961,0a6,6,0,0,0-.333,1.927h2.036a8.068,8.068,0,0,0-.957-3.332,1.025,1.025,0,0,0-1.758,0,9.9,9.9,0,0,0-1.208,3.393l2.036.271v-4.268a1.018,1.018,0,1,0-2.036,0,55.174,55.174,0,0,1-.448,6.854l2-.271a11.651,11.651,0,0,0-1.16-3.176,1.025,1.025,0,0,0-1.758,0,18.568,18.568,0,0,1-3.753,5.728l1.7.448-.3-1.7c-.156-.9-1.432-.93-1.859-.244a4.465,4.465,0,0,0-.617,3.5c.17.964,1.391.862,1.859.244a23.826,23.826,0,0,0,1.961-3.074l-1.758-1.031a11.577,11.577,0,0,0-.95,3.2c-.122.9.943,1.832,1.7.991a13.572,13.572,0,0,0,3.081-5.605c.251-.923-1.025-1.8-1.7-.991a38.88,38.88,0,0,0-3.393,4.75l1.859.787,2.07-7.716a1.025,1.025,0,0,0-1.859-.787l-4.072,5.9c-.76,1.093.984,2.036,1.758,1.025l5.537-7.329c.787-1.045-.977-2.036-1.758-1.031Z",
    transform: "translate(-211.166 -164.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M527.043,369.282c8.143-4.981,14.617-12.412,21.811-18.628,7.8-6.739,15.995-13.016,24.43-18.96,16.382-11.536,33.585-21.858,50.774-32.153a1.018,1.018,0,0,0-1.025-1.758c-17.189,10.295-34.4,20.6-50.781,32.153-7.729,5.429-15.276,11.184-22.51,17.291-7.872,6.65-14.882,14.93-23.752,20.3-1.12.679-.1,2.443,1.025,1.758Z",
    transform: "translate(-254.274 -143.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M696.553,253.847c-8.822.9-18.323,3.142-23.751,10.858-4.689,6.637-4.587,18.214-.183,25.027,5,7.743,15.221,8.021,23.161,5.517s16.158-6.895,16.083-16.382c-.041-5.09-1.88-10.39-3.909-15-1.751-3.983-4.852-7.465-9.548-7.024-1.3.122-1.31,2.158,0,2.036,6.291-.584,8.313,6.888,9.806,11.6,1.357,4.4,2.613,9.616.482,13.993s-7.268,6.61-11.659,8.211c-4.75,1.724-9.969,2.776-14.93,1.357-9.826-2.748-12.541-15.2-9.711-24.036,3.257-10.179,14.794-13.172,24.193-14.122,1.289-.129,1.3-2.165,0-2.036Z",
    transform: "translate(-300.487 -129.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M716.553,369.847c-8.822.9-18.323,3.142-23.751,10.858-4.689,6.637-4.587,18.214-.183,25.027,5,7.743,15.221,8.021,23.161,5.517s16.158-6.895,16.083-16.382c-.041-5.09-1.88-10.39-3.909-15-1.751-3.983-4.852-7.465-9.548-7.024-1.3.122-1.31,2.158,0,2.036,6.291-.584,8.313,6.888,9.806,11.6,1.357,4.4,2.613,9.616.482,13.993s-7.268,6.61-11.659,8.211c-4.75,1.724-9.969,2.776-14.929,1.357-9.826-2.748-12.541-15.2-9.711-24.036,3.257-10.179,14.794-13.172,24.193-14.122,1.289-.129,1.3-2.165,0-2.036Z",
    transform: "translate(-306.915 -167.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M689.734,266.621l6.426,7.329a1.025,1.025,0,0,0,1.7-.455c1.357-3.57,1.1-7.268,1.418-11.021a36.284,36.284,0,0,1,2.884-11.245,37.954,37.954,0,0,1,15.187-17.406c1.12-.679.1-2.443-1.025-1.758a39.847,39.847,0,0,0-15.357,16.87,39,39,0,0,0-3.393,10.77c-.679,4.4-.061,9.019-1.69,13.247l1.7-.455-6.393-7.315c-.869-.984-2.3.461-1.439,1.439Z",
    transform: "translate(-306.975 -122.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M532.134,413.442q52.5-1.6,105.036-.679a1.019,1.019,0,0,0,0-2.036q-52.518-.937-105.036.679C530.824,411.447,530.817,413.482,532.134,413.442Z",
    transform: "translate(-256.087 -180.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M697.853,384.346a210.317,210.317,0,0,1,34.385,17.278c1.113.678,2.138-1.065,1.025-1.758a212.557,212.557,0,0,0-34.84-17.481c-1.215-.482-1.744,1.486-.536,1.961Z",
    transform: "translate(-309.455 -171.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M720.727,371.561a83.13,83.13,0,0,0-19.958,50.577c-.054,1.31,1.981,1.31,2.036,0A80.85,80.85,0,0,1,722.166,373c.848-.991-.584-2.436-1.439-1.439Z",
    transform: "translate(-310.601 -167.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M329.752,402.453l75.849-.991,8.72-.115c1.568,0,3.135-.054,4.7-.061a3.74,3.74,0,0,1,3.651,4.072c-.1,4.75-3.088,4.581-7,4.75l-9.426.428-38.382,1.69c-6.874.305-13.755.679-20.63.916-6.2.19-18-1.832-15.242-10.858.38-1.255-1.581-1.792-1.968-.543-1.357,4.438,1.045,8.944,4.913,11.272,5.49,3.3,12.724,2.178,18.784,1.907l47.123-2.138,11.441-.509c2.932-.136,7.01.461,9.7-.9,3.162-1.595,3.719-7.926,1.724-10.593-1.025-1.357-2.463-1.479-4.072-1.54-4.221-.163-8.517.115-12.744.17l-23.494.312-53.685.679a1.019,1.019,0,0,0,0,2.036Z",
    transform: "translate(-191.037 -176.474)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.63 152.431)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M777.3,764.692c-1.71,1.072-3.664,1.676-5.429,2.619s-3.481,2.362-3.983,4.316a2.714,2.714,0,0,0,.088,1.846,3.583,3.583,0,0,0,1.9,1.507,28.835,28.835,0,0,0,22.808.258,30.032,30.032,0,0,1,3.936-1.561,25.573,25.573,0,0,1,5.042-.516,38.768,38.768,0,0,0,5.3-.679,4.663,4.663,0,0,0,2.4-1,4.459,4.459,0,0,0,1.079-2.592,21.343,21.343,0,0,0-3.393-15.12,5.109,5.109,0,0,0-1.479-1.568,5.708,5.708,0,0,0-2.355-.631c-3.393-.414-6.949-1.174-10.376-1.255-2.457-.054-3.692,1.113-5.429,2.8C783.817,756.712,781.72,761.93,777.3,764.692Z",
    transform: "translate(-767.762 -441.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M855.311,764.037c0,3.325.4,6.847,2.416,9.5a12.551,12.551,0,0,0,3.3,2.884c4.262,2.714,9.908,3.712,14.4,1.411a4.275,4.275,0,0,0,1.792-1.506c.679-1.181.319-2.653-.061-3.956l-6.5-22.53c-4.2.645-10.376,1.1-14.108,3.23C853.838,754.611,855.311,761.064,855.311,764.037Z",
    transform: "translate(-795.77 -441.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M774.616,563.43c-.394,1.242-1.819,1.819-2.6,2.864a5.436,5.436,0,0,0-.489,4.425,11.7,11.7,0,0,0,2.979,5.87,7.038,7.038,0,0,0,6.107,2.077,5.089,5.089,0,0,0,4.146-4.567,8.647,8.647,0,0,0-.638-2.938L779.5,557.777a.506.506,0,0,0-.835-.366c-1.093.516-3.285,1.059-3.922,2.192S775.077,562.2,774.616,563.43Z",
    transform: "translate(-768.896 -379.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M773,560.091c1.69-.265,3.169-1.255,4.75-1.907s3.563-.9,4.893.183c.38.312.746.74,1.242.733a48.592,48.592,0,0,0-3.04-9.663.753.753,0,0,0-.265-.373.767.767,0,0,0-.577,0l-4.567,1.194c-1.69.441-1.887.305-1.758,1.968C773.713,552.965,774.093,560.091,773,560.091Z",
    transform: "translate(-769.445 -377.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M770.967,422.813a6.432,6.432,0,0,0-.679,3.576,121.588,121.588,0,0,0,.95,17.99c.21,1.425.475,2.85.611,4.289a49.482,49.482,0,0,1,.1,6.019l-.679,26.127c-.082,3.2-.244,6.63-2.219,9.141a4.37,4.37,0,0,0-.794,2.9c.516,6.555,1.6,13.057,2.681,19.537a12.073,12.073,0,0,1,10.953.523,120.562,120.562,0,0,0,5.626-33.252c.156-5.558-.081-11.15.774-16.64,1.432-9.243.848-18.723-.2-28.02-.333-2.945-1.038-5.979-2.925-8.259a12.52,12.52,0,0,0-6.786-3.909C775.86,422.175,773.614,422.854,770.967,422.813Z",
    transform: "translate(-767.915 -336.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M770.967,422.813a6.432,6.432,0,0,0-.679,3.576,121.588,121.588,0,0,0,.95,17.99c.21,1.425.475,2.85.611,4.289a49.482,49.482,0,0,1,.1,6.019l-.679,26.127c-.082,3.2-.244,6.63-2.219,9.141a4.37,4.37,0,0,0-.794,2.9c.516,6.555,1.6,13.057,2.681,19.537a12.073,12.073,0,0,1,10.953.523,120.562,120.562,0,0,0,5.626-33.252c.156-5.558-.081-11.15.774-16.64,1.432-9.243.848-18.723-.2-28.02-.333-2.945-1.038-5.979-2.925-8.259a12.52,12.52,0,0,0-6.786-3.909C775.86,422.175,773.614,422.854,770.967,422.813Z",
    transform: "translate(-767.915 -336.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M783.429,530.261a119.85,119.85,0,0,0,7.139,69.381,18.819,18.819,0,0,1,1.656,5.13c.373,3.325-1.16,6.521-2.036,9.738-2.036,7.315-.862,15.106.441,22.591q.814,4.682,1.676,9.358c.563,3.04,1.106,6.345-.305,9.1,1.215,5.063,1.934,10.077,3.149,15.14a2.878,2.878,0,0,1,.115,1.242,3.658,3.658,0,0,1-1.242,1.663,7.424,7.424,0,0,0-1.893,7.105c3.1-2.226,7.424-1.445,10.966,0s7.03,3.393,10.858,3.393c-.556-4.492-1.093-9.209.563-13.423.964-2.443,2.66-4.75,2.613-7.363-.048-2.341-1.479-4.431-1.825-6.745a17.07,17.07,0,0,1,.163-4.316c.909-8.306-.122-16.694-1.154-24.987a14.931,14.931,0,0,0-1.14-4.75,7.014,7.014,0,0,1-1.188-3.006c0-1.269,1.025-2.3,1.4-3.508.679-2.226-.57-5.253,1.31-6.63,4.954-3.637,3.054-12.324,2.945-18.465q-.129-7.947-.679-15.88a67.638,67.638,0,0,1,3.746,27.375c-.217,3.04-.617,6.236.57,9.046.909,2.158,2.714,3.936,3.2,6.223a26.044,26.044,0,0,1,.156,4.309,4.44,4.44,0,0,0,1.8,3.732c.1,6.542.679,13.538.78,20.08a49.527,49.527,0,0,0,.814,9.976,12.716,12.716,0,0,1,.5,3.217,13.445,13.445,0,0,1-1.072,3.956,22.686,22.686,0,0,0,3.393,20.935c1.6-2.843,4.94-4.35,8.2-4.587s6.474.584,9.63,1.411a18.859,18.859,0,0,1,2.253-11.469,9.385,9.385,0,0,0,1.188-2.552c.366-1.724-.489-3.441-.95-5.144-.753-2.714-.489-5.639-.312-8.476a134.128,134.128,0,0,0-1.255-28.447,24.1,24.1,0,0,0-1.3-5.429c-.244-.624-.543-1.221-.746-1.853a14.6,14.6,0,0,1-.543-3.474L846.242,603c-.55-7.607,1.948-15.12,3.692-22.544.78-3.325,1.629-6.644,2.151-10.023.713-4.6.828-9.3,1.873-13.844.936-4.072,2.626-8.042,2.979-12.215.543-6.467-2.144-12.717-4.75-18.648-1.086-2.443-5.191-2.2-7.831-2.633-18.723-3.074-38.443-3.094-56.1,3.834A13.96,13.96,0,0,0,783.429,530.261Z",
    transform: "translate(-772.084 -368.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M803.062,354.449l2.077,8.076a21.581,21.581,0,0,1,.93,5.707,4.215,4.215,0,0,1-.455,2.036,4.853,4.853,0,0,1-1.289,1.316c-1.418,1.079-2.4,3.6-4.024,4.343.835,1.452,1.988.509,3.495,1.235,2.653,1.289,5.083,3.142,7.96,3.78,2.714.6,5.565.034,8.259-.679a28.519,28.519,0,0,0,10.695-4.974c3.074-2.5,4.825-4.716,4.811-8.673-3.393.4-6.413-3.027-7.913-6.108a16.593,16.593,0,0,1-1.14-3.658l-1.819-8c-1.982.434-3.6,1.853-5.49,2.592a19.931,19.931,0,0,1-6.236.9,67.179,67.179,0,0,0-11.1,1.439c-.5.1-1.133.421-1.011.909",
    transform: "translate(-778.219 -312.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M803.062,354.449l2.077,8.076a21.581,21.581,0,0,1,.93,5.707,4.215,4.215,0,0,1-.455,2.036,4.853,4.853,0,0,1-1.289,1.316c-1.418,1.079-2.4,3.6-4.024,4.343.835,1.452,1.988.509,3.495,1.235,2.653,1.289,5.083,3.142,7.96,3.78,2.714.6,5.565.034,8.259-.679a28.519,28.519,0,0,0,10.695-4.974c3.074-2.5,4.825-4.716,4.811-8.673-3.393.4-6.413-3.027-7.913-6.108a16.593,16.593,0,0,1-1.14-3.658l-1.819-8c-1.982.434-3.6,1.853-5.49,2.592a19.931,19.931,0,0,1-6.236.9,67.179,67.179,0,0,0-11.1,1.439c-.5.1-1.133.421-1.011.909",
    transform: "translate(-778.219 -312.728)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 17.97,
    cy: 17.97,
    r: 17.97,
    transform: "translate(15.79 10.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M814.917,374.788a16.288,16.288,0,0,1,4.072-5.429c2.531-2.219,5.992-4.017,6.589-7.329l5.483,6.386a2.954,2.954,0,0,1,.679,1.045,2.633,2.633,0,0,1-.516,2.11c-1.357,2.165-3.495,3.712-5.517,5.28a167.543,167.543,0,0,0-13.294,11.726,1.358,1.358,0,0,1-.713.434,1.282,1.282,0,0,1-.74-.21,30.869,30.869,0,0,1-9.48-7.709c-.2-.238-.441-.509-.76-.489a.977.977,0,0,0-.509.265c-1.826,1.493-3.821,3.278-6.162,3.047,3.033-2.178,4.75-5.816,5.388-9.5a17.944,17.944,0,0,1,.774-3.712,3.875,3.875,0,0,1,2.647-2.511c-1.479,2.26-.468,5.463,1.52,7.288a14.984,14.984,0,0,0,6.732,3.264C813.418,379.179,814.1,376.566,814.917,374.788Z",
    transform: "translate(-776.211 -316.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M786.349,531.1c2.558.631,4.981,1.7,7.465,2.5a35.675,35.675,0,0,0,14.013,1.473,7.567,7.567,0,0,0,4.072-1.3c.319-.258.611-.563.95-.8a6.643,6.643,0,0,1,1.825-.753c6.223-1.948,11.435-6.148,16.49-10.261.163-.136.346-.305.332-.523a.679.679,0,0,0-.2-.387L828.634,518c-6.976,1.188-14.122.74-21.2.563a30.793,30.793,0,0,0-4.357.115c-1.4.163-2.775.516-4.153.814-5.232,1.14-10.58,1.574-15.88,2.321a2.451,2.451,0,0,0-1.052.326,2.369,2.369,0,0,0-.563.624l-1.859,2.613a8.222,8.222,0,0,0-1.561,2.993c-.434,2.036.475,2.714,2.206,2.45A16.11,16.11,0,0,1,786.349,531.1Z",
    transform: "translate(-771.021 -367.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M804.869,388.521a33.056,33.056,0,0,0-7-5.463,9.914,9.914,0,0,0-3.393-1.357,4.235,4.235,0,0,0-3.474.855c-.6.536-.984,1.283-1.568,1.846a7.8,7.8,0,0,1-2.484,1.4,44.054,44.054,0,0,0-8.727,4.974,20.02,20.02,0,0,0-3.956,3.651c-3.074,3.936-3.536,9.29-3.454,14.285.061,3.474,3.393,6.053,5.687,8.652a63.75,63.75,0,0,1,5.823,8.143c1.235,1.954,2.524,4.072,2.368,6.4-.129,1.907-1.242,3.7-1.065,5.6.061.679.278,1.3.339,1.961.122,1.357-.414,2.714-.55,4.072-.183,1.92.441,3.827.475,5.761a18.322,18.322,0,0,1-.5,3.929c-1.3,6.2-2.938,12.439-2.606,18.77l-3.76.679a3.176,3.176,0,0,1-.726,5.069c5.87,1.961,12.215.97,18.438.964,5.151,0,10.281.679,15.425.584s10.451-1.025,14.692-3.936c1.154-.787,2.212-1.71,3.427-2.4a16.905,16.905,0,0,1,5.191-1.7,51.512,51.512,0,0,1,10.179-.909c1.669,0,3.488.068,4.818-.936,1.466-1.113,1.839-3.128,2.036-4.954.2-1.927.319-3.861.353-5.8a24.988,24.988,0,0,0-.238-4.506,29.5,29.5,0,0,0-.794-3.23l-2.558-9.012c-1.059-3.719.414-7.8.726-11.652a2.922,2.922,0,0,0-.611-2.552c-.251-.21-.6-.353-.679-.679a1.16,1.16,0,0,1,.163-.909,50.242,50.242,0,0,1,5.252-7.56,154.488,154.488,0,0,0,8.686-13.348,42.949,42.949,0,0,0-11.5-25.706,12.437,12.437,0,0,0-4.811-3.549,14.251,14.251,0,0,0-3.827-.618c-5.32-.36-10.858-.679-15.493-3.352a2.946,2.946,0,0,0-1.106-.468c-1.025-.115-1.771.9-2.436,1.7-1.71,2.036-4.228,3.2-6.44,4.7C811.071,380.738,807.848,384.592,804.869,388.521Z",
    transform: "translate(-768.741 -320.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M891.576,421.616c1.059,3.352.957,6.935,1.3,10.43a40.6,40.6,0,0,0,1.106,6.25,9.975,9.975,0,0,0,1.289,3.183,14.01,14.01,0,0,1,1.873,2.633,6.358,6.358,0,0,1,.278,2.117l.081,4.682A16.838,16.838,0,0,1,896.4,458.2l-2.925,8.9c-1.581,4.818-3.2,9.711-6.053,13.9a4.009,4.009,0,0,1-1.744,1.635,8.471,8.471,0,0,1-1.758.272A4.52,4.52,0,0,0,880.2,487.3a10.309,10.309,0,0,0-2.5-2.558l-5.951-4.75a25.439,25.439,0,0,0-6.63-4.3,17.976,17.976,0,0,0,12.5-15.106,6.786,6.786,0,0,1,.679-2.972c.5-.8,1.412-1.412,1.479-2.355.081-1.188-1.262-2.083-1.262-3.271,0-.787.584-1.439.842-2.178a5.472,5.472,0,0,0,0-2.789l-.821-4.56a3.485,3.485,0,0,0-.407-1.3,8.426,8.426,0,0,0-1.018-1.072c-1.411-1.581-.787-4.072,0-6.019a57.529,57.529,0,0,1,6.935-12.168,41.6,41.6,0,0,0,2.762-3.95c.719-1.249.882-2.979,1.642-4.072C889.418,416.445,890.741,418.976,891.576,421.616Z",
    transform: "translate(-799.048 -333.628)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M862.978,505.086a3.269,3.269,0,0,0-.774.814,6.861,6.861,0,0,1-3.074,2.192c.679.489,1.3.97,1.934,1.466a84.75,84.75,0,0,1,12.894,12.33c.428-1.527,2.986-1.418,3.61-2.877a2.818,2.818,0,0,0,.136-1.3,39.743,39.743,0,0,0-.977-6.786,7.682,7.682,0,0,0-1.357-3.176,8.144,8.144,0,0,0-3.841-2.172C869.391,504.828,865.149,503.776,862.978,505.086Z",
    transform: "translate(-797.126 -362.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M847.1,512.212c-2.036,1.506-3.821,3.393-6.107,4.424-1.615.733-3.454,1.052-4.866,2.144a4.835,4.835,0,0,0,4.615,2.5,10.967,10.967,0,0,0,5.164-1.893c1.215-.746,2.64-1.615,3.963-1.093.2,1.031-.679,2-.679,3.047a3.072,3.072,0,0,0,1.724,2.355c4.072,2.626,9.311,2.409,14.163,2.1a1.275,1.275,0,0,0,.78-.231,1.228,1.228,0,0,0,.292-.9c.061-1.072.088-2.138.1-3.21a4.6,4.6,0,0,0-1.968-4.533,55.376,55.376,0,0,0-8.483-6.006C852.81,509.192,849.784,510.217,847.1,512.212Z",
    transform: "translate(-789.734 -364.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M824.476,326.088c-3.013.36-5.2,2.714-4.9,5.273s2.993,4.323,6.006,3.956,5.2-2.714,4.9-5.266S827.489,325.728,824.476,326.088Zm1.025,8.523c-2.552.305-4.825-1.194-5.09-3.352s1.6-4.153,4.146-4.459,4.825,1.194,5.09,3.352-1.6,4.153-4.146,4.459Z",
    transform: "translate(-784.405 -305.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M802.836,328.688c-3.013.36-5.2,2.714-4.9,5.266s2.993,4.323,6.006,3.963,5.2-2.714,4.9-5.273S805.849,328.328,802.836,328.688Zm1.025,8.517c-2.552.305-4.825-1.194-5.083-3.346s1.595-4.153,4.146-4.465,4.825,1.194,5.083,3.352S806.406,336.9,803.861,337.2Z",
    transform: "translate(-777.451 -306.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M663.151,259.64l6.549,1.4-.645,1.724-6.175-1.812Z",
    transform: "translate(-648.671 -235.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M714.21,253.18l-6.04,2.911,1.038,1.52,5.571-3.223Z",
    transform: "translate(-663.227 -233.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M687.31,260.8l4.594-.55-.237,1.14-3.943.265Z",
    transform: "translate(-656.523 -236.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M794.717,318.809a7.288,7.288,0,0,0,.679-2.966,6.331,6.331,0,0,1,.312-1.805,5.051,5.051,0,0,1,1.479-1.893,13.687,13.687,0,0,1,8.143-2.843,18.825,18.825,0,0,1,9.419,2.036,7.328,7.328,0,0,1,2.341,1.737c.95,1.16,1.154,2.66,2.11,3.807a5.544,5.544,0,0,0,5.2,1.629c.333-1.181-.1-2.429.068-3.637a17.592,17.592,0,0,1,1.079-3.013,7.406,7.406,0,0,0-3.644-8.551,14.068,14.068,0,0,1-3.244-2.036,15.356,15.356,0,0,1-1.595-2.782c-1.513-2.423-5.429-3.556-8.408-2.436-.937.353-1.764.889-2.714,1.269a22.374,22.374,0,0,1-5.714,1.1,17.5,17.5,0,0,0-5.537,1.452,6.2,6.2,0,0,0-3.468,3.746c-.183.733-.143,1.493-.326,2.219-.937,3.685-6.983,5.476-7.322,9.236a5.39,5.39,0,0,0,1.541,3.766c.638.753,2.165,2.769,3.244,3.061s1.9-.733,2.932-1.086C792.918,320.308,793.9,320.2,794.717,318.809Z",
    transform: "translate(-772.839 -295.621)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M912.81,682c0,34.094,21.39,61.686,47.822,61.686",
    transform: "translate(-378.748 -267.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M983.28,743.368c0-34.48,23.874-62.378,53.373-62.378",
    transform: "translate(-401.396 -267.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M938.35,686.56c0,32.39,13.64,58.6,30.49,58.6",
    transform: "translate(-386.956 -268.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M983.28,735.16c0-44.056,27.593-79.71,61.686-79.71",
    transform: "translate(-401.396 -258.834)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 11.889,
    cy: 2.009,
    rx: 11.889,
    ry: 2.009,
    transform: "translate(567.925 484.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M968.46,771.815s6.786-.21,8.822-1.663,10.43-3.2,10.939-.862,10.179,11.611,2.531,11.672-17.793-1.194-19.829-2.436S968.46,771.815,968.46,771.815Z",
    transform: "translate(-396.633 -295.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M990.895,781.88c-7.655.061-17.786-1.194-19.829-2.436-1.554-.943-2.172-4.343-2.382-5.9h-.224s.427,5.47,2.47,6.711,12.174,2.5,19.829,2.436c2.212,0,2.972-.808,2.932-1.968C993.385,781.425,992.578,781.867,990.895,781.88Z",
    transform: "translate(-396.633 -296.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M148.31,711.36c0,27.145,17.013,49.077,38.043,49.077",
    transform: "translate(-133.048 -276.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.37,760.177c0-27.43,19-49.627,42.461-49.627",
    transform: "translate(-151.065 -276.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.62,715c0,25.787,10.858,46.621,24.26,46.621",
    transform: "translate(-139.575 -277.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M204.37,753.646c0-35.05,21.953-63.416,49.077-63.416",
    transform: "translate(-151.065 -270.012)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.46,
    cy: 1.602,
    rx: 9.46,
    ry: 1.602,
    transform: "translate(42.196 489.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M192.58,782.79s5.395-.17,7.017-1.357,8.306-2.545,8.707-.679,8.109,9.236,2.036,9.283-14.156-.95-15.778-1.934S192.58,782.79,192.58,782.79Z",
    transform: "translate(-147.276 -298.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M210.428,790.857c-6.108.047-14.156-.95-15.778-1.941-1.235-.746-1.724-3.454-1.893-4.7h-.176s.339,4.35,1.961,5.341,9.691,1.982,15.778,1.934c1.758,0,2.368-.638,2.334-1.568C212.409,790.47,211.737,790.816,210.428,790.857Z",
    transform: "translate(-147.276 -300.219)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup2);
export default __webpack_public_path__ + "static/media/sup2.f84d65265272cc94dbf643e742402b87.svg";
export { ForwardRef as ReactComponent };